
import type { PropType } from 'vue'
import type { ColorEnum } from '../enums/color.enum'
import { defineComponent } from 'vue'

import { EpbBadge } from './shared/epb-badge'
import { EpbText } from './shared/epb-text'

export interface Kpi {
  label: string
  icon: string
  color: string
  value: string
  iconColor?: ColorEnum
}

export default defineComponent({
  name: 'KpiCounterBanner',
  components: { EpbBadge, EpbText },
  props: {
    kpis: {
      type: Array as PropType<Array<Kpi>>,
      required: true,
    },
  },
  setup() {
    const baseClass = 'epb-kpi-counter-banner'

    return {
      baseClass,
    }
  },
})
